import aboutLeft from '../assets/about-left-transparent.png';
import brands1 from '../assets/brand01_crop.jpg';
import brands2 from '../assets/brand02_crop.jpg';
import brands3 from '../assets/brand03_crop.jpg';
import brands4 from '../assets/brand04_crop.jpg';
import brands5 from '../assets/brand05_crop.jpg';
import brands6 from '../assets/brand06_crop.jpg';
import brands7 from '../assets/brand07_crop.jpg';
import clientTemp from '../assets/client_temp.jpeg';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo-light.png';
import logo3 from '../assets/logo-dark.png';
import logo4 from '../assets/logo-light2.png';
import logo5 from '../assets/logo-dark2.png';
import goli from '../assets/goli.png'
import seventhAve from '../assets/seventh-avenue.png'
import seventhAve2 from '../assets/seventh-avenue-2.png'
import desireeFinery from '../assets/desiree-finery.png'

export default {
    aboutLeft,
    brands1,
    brands2,
    brands3,
    brands4,
    brands5,
    brands6,
    brands7,
    clientTemp,
    logo,
    logo2,
    logo3,
    logo4,
    logo5,
    goli,
    seventhAve,
    seventhAve2,
    desireeFinery
}